import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import StyledInput from './Styled';

export default function Input({
  label,
  name,
  type,
  onChange,
  placeholder,
  ...rest
}) {
  const inputRef = useRef(null);

  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  function handleChange() {
    clearError();

    if (onChange) {
      onChange();
    }
  }

  return (
    <StyledInput
      ref={inputRef}
      label={label}
      placeholder={placeholder}
      type={type}
      onChange={() => handleChange()}
      error={error}
      defaultValue={defaultValue}
      {...rest}
    />
  );
}
